import { useMemo } from 'react';
import { useGetChildren, useGetItem, useThumbnailUrl } from './onedrive';
import { useSidecarFile } from './sidecar';
import { Section } from './sidecar.types';

export const useSections = (categoryId: string) => {
  const [children] = useGetChildren(categoryId);
  return useMemo(() => children.value.filter(child => child.folder), [children]);
};

export const useSectionDetails = (id: string) => {
  const folderDetails = useGetItem(`${id}`);
  const folderData = folderDetails[0];

  if (!folderData) {
    throw Error('Could not get data for folder');
  }

  if (!folderData.name) {
    throw Error('Could not get name for folder');
  }

  const details = useSidecarFile<Section>(`${id}:/Section.sidecar`);

  if (!details || !details[0]) {
    // The sidecar file has yet to be created.
    // Return an incomplete section.
    const section: Section = {
      name: folderData.name
    };

    return {
      sectionData: section
    };
  }

  const sectionData = details[0].data;

  if (!sectionData || !folderData) {
    throw Error('Could not get section');
  }

  const thumbnailUrl = useThumbnailUrl(sectionData.coverImageDriveId);

  const imageUrl = thumbnailUrl || sectionData.coverImage;

  if (!sectionData.name && folderData.name) {
    sectionData.name = folderData.name;
  }

  return { sectionData, imageUrl };
};
